<!--分配完成--->
<template>
    <div class="page flex-col">
        <div class="distribution-box flex-col">
            <img class="group_5" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/checked.png" alt="" />
            <span class="text_3">分配完成</span>
            <span class="paragraph_1">成员将立即收到客户群的继承提醒<br />24小时自动继续客户后，还将收到顾客的继承提醒</span>
            <div class="section_1 flex-row justify-between">
                <img class="block_1" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/notice.png" alt="" />
                <div class="text-group_2">
                    <span class="text_8">企业中还有{{ employeesCount }}位离职成员的顾客与顾客群待分配，</span>
                    <span class="text_9" @click="toquitInherit()">继续分配</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import request from "@/utils/request";

    export default {
        name: "allocatedSuccess",
        data() {
            return {
                employeesCount: 0,  //剩余离职人员
            };
        },

        mounted() {
            this.onLoad();
        },
        methods: {
            onLoad() {
                request({
                    url: `/workEmployee/getAllResEmp`,
                    method: "get",
                })
                    .then((res) => {
                        this.employeesCount = res.data.length;
                    })
            },

            toquitInherit() {
                this.$router.push({ name: "quitInherit", query: {} });
            }
        },
    };
</script>


<style scoped>
    .page {
        position: relative;
        width: 750px;
        height: 1630px;
        background-color: rgba(255, 255, 255, 1);
        overflow: hidden;
    }

    .distribution-box {
        width: 750px;
        height: 950px;
    }

    .text_3 {
        width: 152px;
        height: 53px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 38px;
        white-space: nowrap;
        line-height: 53px;
        text-align: left;
        margin: 30px 0 0 290px;
    }

    .group_5 {
        width: 80px;
        height: 80px;
        margin: 280px 0 0 331px;
    }

    .paragraph_1 {
        width: 630px;
        height: 80px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 28px;
        line-height: 40px;
        text-align: center;
        margin: 30px 0 0 60px;
    }

    .section_1 {
        width: 489px;
        height: 80px;
        margin: 141px 0 0 130px;
    }

    .block_1 {
        width: 35px;
        height: 31px;
        margin-top: 7px;
    }

    .text-group_2 {
        width: 434px;
        height: 80px;
        overflow-wrap: break-word;
        text-align: left;
        font-size: 0;
        margin-left: 10px;
    }

    .text_8 {
        font-size: 28px;
        color: rgba(160, 172, 181, 1);
        line-height: 40px;
    }

    .text_9 {
        font-size: 28px;
        color: rgba(67, 117, 201, 1);
        line-height: 40px;
    }
</style>
